import { useMemo } from 'react';
import { GlobalAttribute } from 'types/common';
import {
  SITE_WEEK_DAYS,
  STAFF_CLOSE_HOUR_IN_SECONDS,
  STAFF_OPEN_HOUR_IN_SECONDS,
} from '../../../../configs/siteAndTrustAttributes';
import {
  formatSecondsOfDayIntoTime,
  parseTimeInHHmmToSecondsOfDay,
} from '../../../../utils/dateUtil';
import {
  siteAttributeKeysSubset,
  updateSiteAttributes,
} from '../SitePreferencesHooks';
import { UseGeneralSitePreferencesFormHooks } from './GeneralSitePreferencesHooks';

const keys = siteAttributeKeysSubset([SITE_WEEK_DAYS]);

const restAttributes: GlobalAttribute[] = keys.map((key) => ({ key }));

export const useAvailabilityFormHooks: UseGeneralSitePreferencesFormHooks = ({
  site,
}) => {
  const defaultValues = useMemo(
    () => {
      const lengthFromSite = site.appt_length;
      return {
        openHourTime: formatSecondsOfDayIntoTime(
          site.attributes?.find((atr) => atr.key === STAFF_OPEN_HOUR_IN_SECONDS)
            ?.value_int,
        ),
        closeHourTime: formatSecondsOfDayIntoTime(
          site.attributes?.find(
            (atr) => atr.key === STAFF_CLOSE_HOUR_IN_SECONDS,
          )?.value_int,
        ),
        appointmentLength: lengthFromSite,
      };
    },
    // shallow comparison is fine here as we are using it for default form value only
    [site.appt_length, site.attributes],
  );

  return {
    restAttributes,
    defaultValues,
    beforeSubmit: (updatedSite, formValues) => {
      const { openHourTime, closeHourTime, appointmentLength } = formValues;
      return {
        ...updatedSite,
        appt_length: appointmentLength as number,
        attributes: updateSiteAttributes(
          updatedSite.attributes,
          formValues.attributes,
          [...keys, STAFF_OPEN_HOUR_IN_SECONDS, STAFF_CLOSE_HOUR_IN_SECONDS],
          (key, siteValue, formValue) => {
            switch (key) {
              case STAFF_OPEN_HOUR_IN_SECONDS:
              case STAFF_CLOSE_HOUR_IN_SECONDS:
                const time =
                  key === STAFF_OPEN_HOUR_IN_SECONDS
                    ? openHourTime
                    : closeHourTime;
                const inSeconds = parseTimeInHHmmToSecondsOfDay(time);
                return {
                  key,
                  value_int: inSeconds,
                  value_str: time,
                };
              default:
                return formValue || siteValue;
            }
          },
        ),
      };
    },
  };
};
